import Logo from "../components/Logo"
import Card from "../components/Card"
import Button from "../components/Button"
import { useNavigate } from "react-router-dom"

function NotFound() {
  const navigate = useNavigate()

  const handlePrev = () => {
    navigate(-1)
  }
  return (
    <div className="login-container">
    <Logo/>
    <Card>
    <div className="banner error-banner"></div>
    <h4 className="card-head"> 
    Sorry we are unable to find that page!!
    </h4>
    <p className="card-text">
    Looks like the page you want to acess athe moment is not available
    </p>

    <div className="err-btn-group" onClick={handlePrev}>
    <Button>
    Take me back the previous page
    </Button> 
    </div>
   
    </Card>
    
</div>
  )
}

export default NotFound